const state = () => ({
  user: null,
  orderRules: {
    ignoreTimelimit: false,
    isWorker: false,
    canChangeOffices: false,
  },
});

const mutations = {
  SAVE_USER(state, item) {
    // item.companies[0].checkReport = true;
    const userMenu = item?.user_menu?.menu1;
    let menu = [];
    if (userMenu) {
      menu = JSON.parse(userMenu || "[]");
      const guestMenuIndex = menu.findIndex((menuItem) => menuItem?.to?.name === "izvestaj-gost")
      if (guestMenuIndex > -1) {
        menu[guestMenuIndex].to.name = "guest-report";
      }
      const menuGroupIndex = menu.findIndex((menuItem) => menuItem?.to?.name === "menu");
      if (menuGroupIndex > -1) {
        menu[menuGroupIndex].to.name = "restaurant-menu-groups";
      }
    }

    state.user = { ...item, user_menu: { ...item.user_menu, menu1: JSON.stringify(menu) } };
    state.orderRules.ignoreTimelimit =
      !!item.no_time_limit_user || item.type === "company";
    state.orderRules.canChangeOffices =
      !!item.is_transferable && item.type !== 3;
    if (item.companies && item.companies[0]) {
      state.orderRules.isWorker =
        item.companies[0].is_credit !== 1 && item.type === "customer";
    }
  },
  LOGOUT(state) {
    state.user = null;
    state.orderRules.ignoreTimelimit = false;
    state.orderRules.isWorker = false;
    state.orderRules.canChangeOffices = false;
  },
};

const actions = {
  LOGOUT({ commit }) {
    commit("LOGOUT");
    localStorage.removeItem("restoran-token");
    document.cookie =
      "restoran-token=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    commit("RESET", null, { root: true });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
